module.exports = __webpack_public_path__ + "img/eyein-partner-extreme-networks.bb04548c.png";